import { useMutation } from 'react-query'

import { APIError, APIResponse } from '../../../utils'
import { updateAddress } from '../query-api'
import { ShippingAddress } from '../types/shippingAddress'

interface UseUpdateAddressProps {
  onError?: (error?: APIError) => void
  onSuccess?: (data: APIResponse<ShippingAddress>, variables: Partial<ShippingAddress>) => void
}

export const useUpdateAddress = (props?: UseUpdateAddressProps) => {
  const { onError, onSuccess } = props || {}
  const {
    mutate: update,
    mutateAsync: updateAsync,
    isLoading: isProcessing,
    ...rest
  } = useMutation(updateAddress, {
    onSuccess,
    onError,
  })

  return { update, updateAsync, isProcessing, ...rest }
}
